document.addEventListener('click', (e) => {
  const btn = e.target.closest('.service-carousel__nav');
  if (!btn) return;

  const wrapper = btn.closest('.service-carousel-wrapper');
  const track = wrapper && wrapper.querySelector('.service-carousel__track');
  if (!track) return;

  e.preventDefault();

  const slide = track.querySelector('.service-carousel__slide');
  const gap = 16;
  const amount = slide ? slide.offsetWidth + gap : 300;

  if (btn.classList.contains('service-carousel__nav--prev')) {
    track.scrollBy({ left: -amount, behavior: 'smooth' });
  } else {
    track.scrollBy({ left: amount, behavior: 'smooth' });
  }
});
